// Tiny pub/sub so pattern reveals can sequence themselves AFTER the boot splash wipe, without
// hand-tuned delays. `complete` is module-level, so on a full page load it starts false (the splash
// runs, then flips it) and on a soft client-side navigation it's already true (the splash ran on the
// initial load and never replays) — meaning reveals fire immediately on soft-nav, not after a guess.

let complete = false;
const listeners = new Set<() => void>();

export function markBootSplashComplete(): void {
  if (complete) return;
  complete = true;
  listeners.forEach((listener) => listener());
  listeners.clear();
}

/** Runs `listener` when the boot splash finishes — immediately if it already has. Returns an unsubscribe. */
export function whenBootSplashComplete(listener: () => void): () => void {
  if (complete) {
    listener();
    return () => {};
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
